<template>
  <div class="row l-m-b-16 bg-light border-top border-bottom text-center" v-if="type === 'create'">
    <div class="col">
      <div class="text-center d-inline-block px-4 py-2 text-white companies-check-field"
           :class="[step === 'companies-map' ? 'bg-primary check-default' : 'text-dark']"
      >
        <label
          :class="[savedCoverage === true ? 'check-closed pointer' : 'check-open']"
          for="companies-map"
          @click="savedCoverage === true ? setCompanyStep('companies-map') : null"
        >
          <span class="companies-checkmark" />
          <input type="checkbox" value="companies-map" :checked="savedCoverage === true" id="companies-map" />
          <span class="company-steps-title" :class="{'text-white': step === 'companies-map'}">
            Coverage</span>
        </label>
      </div>
      <div class="text-center d-inline-block px-4 py-2 text-white companies-check-field"
           :class="[step === 'companies-settings' ? 'bg-primary check-default' : 'text-dark']"
      >
        <label
          :class="[savedSettings === true ? 'check-closed pointer' : 'check-open', {pointer: savedCoverage === true}]"
          for="companies-settings"
          @click="savedSettings === true || savedCoverage === true ? setCompanyStep('companies-settings') : null"
        >
          <span class="companies-checkmark" />
          <input type="checkbox" value="companies-settings" :checked="savedSettings === true"
                 id="companies-settings"
          />
          <span class="company-steps-title" :class="{'text-white': step === 'companies-settings'}">
            Company Settings</span>
        </label>
      </div>
      <div class="text-center d-inline-block px-4 py-2 text-white companies-check-field"
           :class="[step === 'companies-pricing' ? 'bg-primary check-default' : 'text-dark']"
      >
        <label for="companies-pricing"
               :class="[savedCoverage === true && savedSettings === true ? 'check-open pointer' : '']"
               @click="savedCoverage === true && savedSettings === true ? setCompanyStep('companies-pricing') : null"
        >
          <span class="companies-checkmark" />
          <input type="checkbox" value="companies-pricing" :checked="step === 'companies-pricing'"
                 id="companies-pricing"
          />
          <span class="company-steps-title" :class="{'text-white': step === 'companies-pricing'}">
            Pricing</span>
        </label>
      </div>
    </div>
  </div>
  <div v-else>
    <nav>
      <div class="nav flex-column flex-nowrap overflow-hidden">
        <div :class="[step === 'companies-info' ? 'active' : '']"
             class="nav-item nav-link pointer"
             @click="setCompanyStep('companies-info')"
        >
          Company info
        </div>
        <div :class="[step === 'companies-map' ? 'active' : '']"
             class="nav-item nav-link pointer"
             @click="setCompanyStep('companies-map')"
             v-if="canListCompanyCoverages"
        >
          Coverage
        </div>
        <div :class="[step === 'companies-settings' ? 'active' : '']"
             class="nav-item nav-link pointer"
             @click="setCompanyStep('companies-settings')"
        >
          Company Settings
        </div>
        <div :class="[step === 'companies-pricing' ? 'active' : '']"
             class="nav-item nav-link pointer"
             @click="setCompanyStep('companies-pricing')"
        >
          Pricing
        </div>
        <div :class="[step === 'companies-availability' ? 'active' : '']"
             class="nav-item nav-link pointer"
             @click="setCompanyStep('companies-availability')"
        >
          Availability
        </div>
        <div :class="[step === 'web-quote' ? 'active' : '']"
             class="nav-item nav-link pointer"
             v-if="$_can('companies.mod.update')"
             @click="setCompanyStep('web-quote')"
        >
          Web quote
        </div>
        <div :class="[step === 'companies-profile' ? 'active' : '']"
             class="nav-item nav-link pointer"
             v-if="$_can('companies.mod.update')"
             @click="setCompanyStep('companies-profile')"
        >
          mod24 settings
        </div>
        <div :class="[step === 'billing' ? 'active' : '']"
             class="nav-item nav-link pointer"
             v-if="$_can('companies.mod.update')"
             @click="setCompanyStep('billing')"
        >
          Billing Info
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  props: {
    type: {
      type: String,
      default: 'edit',
    },
    canListCompanyCoverages: {
      type: Boolean,
      default: false,
    },
    canListCompanyPrices: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      step: state => state.companies.step,
      savedSettings: state => state.companies.savedSettings,
      savedCoverage: state => state.companies.savedCoverage,
      company: state => state.companies.company,
    }),
  },
  methods: {
    ...mapMutations(['setCompanyStep']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/CompaniesStepsMenu.vue